import { Injectable } from '@angular/core';
import { GenericService } from '../../../../core/services/GenericService';
import { ApiService, JwtService } from '../../../../core/services';
import { ISeminar } from '../interfaces';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SeminarsService extends GenericService<ISeminar> {

  protected readonly baseUrl = '/seminars';

  public constructor(
    public readonly apiService: ApiService,
    private readonly _jwtService: JwtService,
  ) {
    super(apiService);
  }

  public getAttendeesListDocUrl(seminarEventId: number): Observable<string> {
    const url = `${ environment.apiUrl }${ this.baseUrl }/generate-attendees-list?seminarEventId=${ seminarEventId }&isPrint=true`;

    return this.apiService.getFile(url, 'application/pdf')
      .pipe(map(() => `${ url }&token=${ this._jwtService.getAccessToken() }`));
  }
}
